<div class="ov-toolbar flex align-items-center gap-3">

  <p-button label="Documentada" icon="pi pi-file-check" class="ov-btn-main" [disabled]="btn_documentada"
    (onClick)="onDocumentada()"
    [pTooltip]="btn_documentada ? 'Solo se pueden Documentar OVs Concluidas' : 'Documentar'"></p-button>

  <div class="flex gap-2">
    <!-- futuros botones -->
  </div>

</div>